module.exports = __webpack_public_path__ + "static/media/8OLA21.c3c088e7.jpg";